import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SalesSection.html?raw';

import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import Edit from '../../../moreCore/UI/Edit/Edit';

class SalesSection extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private inputPriceAConcardinate: MdsLax<InstanceType<typeof Edit>>;
    private inputPriceBConcardinate: MdsLax<InstanceType<typeof Edit>>;

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let priceScaleA = this.getAttributeValue("ref_price_scale_A");
        let priceScaleB = this.getAttributeValue("ref_price_scale_B");

        if (priceScaleA) this.inputPriceAConcardinate.setReadonly(true);
        if (priceScaleB) this.inputPriceBConcardinate.setReadonly(true);
    }

    protected onDirtyChange(newState: boolean) {
        this.emit("change", this.getChangedData());
    }

    hasData(): boolean {
        let hasContent = false;
        let currentData = this.getCurrentData();

        let keys = Object.keys(currentData);

        for (let key of keys) {
            switch (key) {
                case "ID":
                case "Classname":
                case "ClassPrintname":
                case "$Displayname":
                    break;
                default:
                    if (currentData[key] && currentData[key].length > 0) return true;
            }
        }


        return hasContent;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(SalesSection);